import { ParsedPlanType } from '../../../pages/Payments/types';

export const getPlanByMemberCount = (memberCount: number, plans: ParsedPlanType[]) => {
	return plans.find((plan) => memberCount >= plan.memberFrom && memberCount <= plan.memberTo);
};
